import { readingTime } from 'reading-time-estimator'

/* eslint-disable no-undef */
import './navigation-drawer'
import './navigation-dropdown'
import './cookies'

// Arrow Up Icon Button
const arrowUpIcon = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.83301 14.1667L14.1663 5.83334M14.1663 5.83334H5.83301M14.1663 5.83334V14.1667" stroke="#05A6F0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`

document
  .querySelectorAll('.btn.contents__blog--cardReadMoreBtn')
  .forEach((el) => {
    el.innerHTML += arrowUpIcon
  })
document
  .querySelectorAll('.btn.otherPost__blogDetail--cardReadMoreBtn')
  .forEach((el) => {
    el.innerHTML += arrowUpIcon
  })
const viewAllBtn = document.querySelector(
  '.btn.otherPost__blogDetail--viewAllBtn',
)
if (viewAllBtn) {
  viewAllBtn.innerHTML += arrowUpIcon
}
const bookDemoBtn = document.querySelector('.btn.btn-book-demo')
if (bookDemoBtn) {
  bookDemoBtn.innerHTML += arrowUpIcon
}

const chevronDownIcon = `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 4.5L6 7.5L9 4.5" stroke="#94A3B8" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`

document.querySelectorAll('.link-item .arrow-down').forEach((el) => {
  el.innerHTML += chevronDownIcon
})

const hamburgerIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 12H21M3 6H21M3 18H21" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`

const hamburgerBtn = document.querySelector('.btn-hamburger')
if (hamburgerBtn) {
  hamburgerBtn.innerHTML += hamburgerIcon
}

// Environment Variable Setup
let rawStrapiUrl =
  process.env.VERCEL_STRAPI_URL && process.env.VERCEL_STRAPI_URL !== 'undefined'
    ? process.env.VERCEL_STRAPI_URL
    : 'https://blogger.wenodo.com'

rawStrapiUrl = rawStrapiUrl.replace(/\/+$/, '')
if (rawStrapiUrl.endsWith('/api')) {
  rawStrapiUrl = rawStrapiUrl.slice(0, -4)
}

const STRAPI_URL = rawStrapiUrl
const STRAPI_TOKEN = process.env.VERCEL_STRAPI_TOKEN || ''
const BASE_URL =
  process.env.VERCEL_BASE_URL && process.env.VERCEL_BASE_URL !== 'undefined'
    ? process.env.VERCEL_BASE_URL
    : ''

function resolveRichText(nodes) {
  if (typeof nodes === 'string') return nodes
  if (!Array.isArray(nodes)) return ''
  return nodes.map((c) => resolveRichTextNode(c)).join('')
}

function resolveRichTextNode(node) {
  if (!node) return ''
  let html = ''
  const children = Array.isArray(node.children)
    ? node.children.map((c) => resolveRichTextNode(c)).join('')
    : ''

  switch (node.type) {
    case 'heading':
      html = `<h${node.level || 1}>${children}</h${node.level || 1}>`
      break
    case 'text':
      if (node.text) {
        let tmp = node.text.replaceAll('\n', '<br />')

        if (node.bold) tmp = `<b>${tmp}</b>`
        if (node.code) tmp = `<code>${tmp}</code>`
        if (node.italic) tmp = `<i>${tmp}</i>`
        if (node.strikethrough) tmp = `<s>${tmp}</s>`
        if (node.underline) tmp = `<u>${tmp}</u>`

        html = tmp
      }
      break
    case 'paragraph':
      html = `<p>${children}</p>`
      break
    case 'link':
      html = `<a href="${node.url || '#'}">${children}</a>`
      break
    case 'list':
      switch (node.format) {
        case 'ordered':
          html = `<ol>${children}</ol>`
          break
        case 'unordered':
        default:
          html = `<ul>${children}</ul>`
          break
      }
      break
    case 'list-item':
      html = `<li>${children}</li>`
      break
    case 'quote':
      html = `<blockquote>${children}</blockquote>`
      break
    case 'code':
      html = `<pre>${children}</pre>`
      break
    case 'image':
      if (node.image?.url) {
        html = `<img src="${node.image.url}" height="${node.image.height || ''}" width="${node.image.width || ''}" alt="${node.image.alternativeText || ''}" />`
      }
      break
  }

  return html
}

function formatTitleSlug(title) {
  if (!title) return ''
  return title.replaceAll(':', '').replaceAll(' ', '-')
}

function getCoverUrl(coverData) {
  if (typeof coverData === 'string') return coverData
  const url = coverData?.data?.attributes?.url || coverData?.url
  if (!url) return ''
  return url.replace('/upload', '/upload/q_auto:eco').replace('.png', '.webp')
}

// Get Data Strapi
const myHeaders = new Headers()
if (STRAPI_TOKEN) {
  myHeaders.append('Authorization', `Bearer ${STRAPI_TOKEN}`)
}

const requestOptions = {
  method: 'GET',
  headers: myHeaders,
  redirect: 'follow',
}

function getBlogSlug(data, id) {
  if (data?.slug) return data.slug
  const title = data?.Title || data?.title
  if (title) {
    return title
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/[\s_-]+/g, '-')
      .replace(/^-+|-+$/g, '')
  }
  return id || ''
}

function getBlogIdentifier() {
  const url = new URL(window.location.href)

  // 1. Check path after /blog-detail.html/ or /blog-detail/
  const pathname = url.pathname.replace(/\/+$/, '')
  const pathParts = pathname.split('/')
  const blogDetailIndex = pathParts.findIndex(
    (p) => p === 'blog-detail.html' || p === 'blog-detail',
  )
  if (blogDetailIndex !== -1 && pathParts[blogDetailIndex + 1]) {
    let slugInPath = decodeURIComponent(
      pathParts.slice(blogDetailIndex + 1).join('/'),
    )
    if (slugInPath) {
      slugInPath = slugInPath.replace(/\.html$/i, '')
      if (slugInPath) return slugInPath
    }
  }

  // 2. Check query parameter: blogId, id, slug
  const blogId = url.searchParams.get('blogId') || url.searchParams.get('id')
  if (blogId) return blogId

  const slugParam = url.searchParams.get('slug')
  if (slugParam) return slugParam

  // 3. Check query string key (e.g. ?welcoming-noreen-london-to-the-wenodo-family)
  const ignoredParams = new Set([
    'category',
    'page',
    'blogid',
    'id',
    'slug',
    'fbclid',
    'gclid',
    'ref',
    'source',
  ])
  const keys = Array.from(url.searchParams.keys())
  for (const k of keys) {
    if (
      k &&
      !ignoredParams.has(k.toLowerCase()) &&
      !k.toLowerCase().startsWith('utm_')
    ) {
      return k
    }
  }

  // 4. Raw search fallback if search is ?slug-string
  const rawSearch = window.location.search
  if (rawSearch && rawSearch.startsWith('?')) {
    const rawContent = decodeURIComponent(rawSearch.slice(1).split('&')[0])
    if (rawContent && !rawContent.includes('=')) {
      return rawContent
    }
  }

  return null
}

function cleanText(text) {
  if (!text) return ''
  return text
    .replace(/<[^>]*>/g, '')
    .replace(/\s+/g, ' ')
    .trim()
}

function setMetaTag(nameOrProperty, content) {
  if (content === undefined || content === null) return
  const cleanContent = String(content).trim()
  const isProperty =
    nameOrProperty.startsWith('og:') || nameOrProperty.startsWith('article:')
  const targetLower = nameOrProperty.toLowerCase()

  const allMetas = Array.from(document.querySelectorAll('meta'))
  const matched = allMetas.filter((m) => {
    const n = (m.getAttribute('name') || '').toLowerCase()
    const p = (m.getAttribute('property') || '').toLowerCase()
    return n === targetLower || p === targetLower
  })

  if (matched.length > 0) {
    matched.forEach((m) => m.setAttribute('content', cleanContent))
  } else {
    const meta = document.createElement('meta')
    meta.setAttribute(isProperty ? 'property' : 'name', nameOrProperty)
    meta.setAttribute('content', cleanContent)
    document.head.appendChild(meta)
  }
}

function setCanonicalTag(url) {
  if (!url) return
  let link = document.getElementById('seo-canonical') || document.querySelector('link[rel="canonical"]')
  if (!link) {
    link = document.createElement('link')
    link.setAttribute('rel', 'canonical')
    document.head.appendChild(link)
  }
  link.setAttribute('href', url)
}

function updateSeoMetadata(dataObj, slug) {
  if (!dataObj) return

  const rawTitle = dataObj.Title || dataObj.title || ''
  const rawMetaTitle =
    dataObj.metaTitle ||
    dataObj.meta_title ||
    dataObj.seo?.metaTitle ||
    rawTitle ||
    'Blog Detail'

  let rawMetaDesc =
    dataObj.metaDescription ||
    dataObj.meta_description ||
    dataObj.seo?.metaDescription ||
    dataObj.summary ||
    dataObj.ogDescription ||
    dataObj.Detail ||
    dataObj.detail ||
    ''

  if (!rawMetaDesc && dataObj.contents) {
    const text =
      typeof dataObj.contents === 'string'
        ? dataObj.contents
        : resolveRichText(dataObj.contents)
    rawMetaDesc = cleanText(text).slice(0, 160)
  }
  if (!rawMetaDesc && dataObj.content) {
    rawMetaDesc = cleanText(dataObj.content).slice(0, 160)
  }

  const cleanDesc = cleanText(rawMetaDesc)
  const cleanMetaTitle = cleanText(rawMetaTitle)
  const finalTitle = cleanMetaTitle.toLowerCase().includes('wenodo')
    ? cleanMetaTitle
    : `${cleanMetaTitle} | Wenodo`

  // 1. Title Tag (both document.title and <title> DOM element)
  document.title = finalTitle
  const titleTag =
    document.getElementById('seo-title') || document.querySelector('title')
  if (titleTag) {
    titleTag.textContent = finalTitle
  }

  // 2. Meta Description (update name="description", og:description, twitter:description)
  if (cleanDesc) {
    setMetaTag('description', cleanDesc)
  }

  // 3. Keywords
  const keywords = dataObj.keywords || dataObj.seo?.keywords || ''
  if (keywords) {
    setMetaTag('keywords', cleanText(keywords))
  }

  // 4. Robots
  const isNoIndex = dataObj.noIndex || dataObj.noindex || false
  setMetaTag(
    'robots',
    isNoIndex ? 'noindex, nofollow' : 'index, follow, max-image-preview:large',
  )

  // 5. Canonical URL
  const siteUrl = 'https://www.wenodo.com'
  const postUrl =
    dataObj.canonicalUrl ||
    dataObj.canonical_url ||
    dataObj.seo?.canonicalUrl ||
    (slug ? `${siteUrl}/blog-detail/${slug}` : `${siteUrl}/blog-detail`)
  setCanonicalTag(postUrl)

  // 6. Cover & OG Image
  const cover = dataObj.cover || dataObj.coverImage || dataObj.ogImage || ''
  const coverUrl = getCoverUrl(cover)
  const ogImageUrl = dataObj.ogImage || coverUrl

  // 7. Open Graph Tags
  const ogTitle = cleanText(
    dataObj.ogTitle || dataObj.og_title || cleanMetaTitle || rawTitle,
  )
  const ogDescription = cleanText(
    dataObj.ogDescription || dataObj.og_description || cleanDesc,
  )

  const finalOgTitle = ogTitle
    ? ogTitle.toLowerCase().includes('wenodo')
      ? ogTitle
      : `${ogTitle} | Wenodo`
    : finalTitle

  setMetaTag('og:title', finalOgTitle)
  setMetaTag('og:description', ogDescription || cleanDesc)
  setMetaTag('og:url', postUrl)
  setMetaTag('og:type', 'article')
  setMetaTag('og:site_name', 'Wenodo')
  if (ogImageUrl) {
    setMetaTag('og:image', ogImageUrl)
  }

  const publishedAt = dataObj.publishedAt || dataObj.createdAt || ''
  if (publishedAt) {
    setMetaTag('article:published_time', publishedAt)
  }
  const updatedAt = dataObj.updatedAt || dataObj.updated_at || publishedAt || ''
  if (updatedAt) {
    setMetaTag('article:modified_time', updatedAt)
  }
  const author = dataObj.author || 'Wenodo Team'
  setMetaTag('article:author', author)

  // 8. Twitter Tags
  setMetaTag('twitter:card', 'summary_large_image')
  setMetaTag('twitter:title', finalOgTitle)
  setMetaTag('twitter:description', ogDescription || cleanDesc)
  if (ogImageUrl) {
    setMetaTag('twitter:image', ogImageUrl)
  }

  // 9. JSON-LD Article Schema
  let schemaScript = document.getElementById('blog-article-jsonld')
  if (!schemaScript) {
    schemaScript = document.createElement('script')
    schemaScript.id = 'blog-article-jsonld'
    schemaScript.type = 'application/ld+json'
    document.head.appendChild(schemaScript)
  }

  const schemaData = {
    '@context': 'https://schema.org',
    '@type': 'BlogPosting',
    headline: cleanMetaTitle || rawTitle,
    description: cleanDesc,
    ...(ogImageUrl ? { image: [ogImageUrl] } : {}),
    ...(publishedAt ? { datePublished: publishedAt } : {}),
    ...(updatedAt ? { dateModified: updatedAt } : {}),
    author: {
      '@type': 'Organization',
      name: author,
      url: 'https://www.wenodo.com',
    },
    publisher: {
      '@type': 'Organization',
      name: 'Wenodo',
      logo: {
        '@type': 'ImageObject',
        url: 'https://www.wenodo.com/assets/image/app-logo.png',
      },
    },
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': postUrl,
    },
  }
  schemaScript.textContent = JSON.stringify(schemaData, null, 2)
}

function slugify(text) {
  if (!text) return ''
  return text
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s_-]+/g, '-')
    .replace(/^-+|-+$/g, '')
}

function renderBlogDetail(dataObj, identifier) {
  if (!dataObj) return

  const activeSlug = getBlogSlug(dataObj, identifier)

  // 1. Update complete SEO metadata FIRST so title, meta description, and tags are set immediately
  try {
    updateSeoMetadata(dataObj, activeSlug || identifier)
  } catch (err) {
    console.error('Error updating SEO metadata:', err)
  }

  const Title = dataObj.Title || dataObj.title || ''
  const publishedAt = dataObj.publishedAt || dataObj.createdAt || ''
  const cover = dataObj.cover || dataObj.coverImage || dataObj.ogImage || ''
  const contents =
    dataObj.contents ||
    dataObj.content ||
    dataObj.Detail ||
    dataObj.summary ||
    ''

  const titleEl = document.querySelector('[data-element="title-blog"]')
  if (titleEl) titleEl.innerHTML = Title

  const readingTimeEl = document.querySelector('[data-element="readingTime"]')
  if (readingTimeEl && contents) {
    const textContent =
      typeof contents === 'string' ? contents : resolveRichText(contents)
    readingTimeEl.innerHTML = readingTime(textContent, 300).text
  }

  const publishedAtEl = document.querySelector('[data-element="publishedAt"]')
  if (publishedAtEl && publishedAt) {
    if (typeof moment !== 'undefined') {
      publishedAtEl.innerHTML = moment(publishedAt).format('MMM. DD, Y')
    } else {
      try {
        publishedAtEl.innerHTML = new Date(publishedAt).toLocaleDateString('en-US', {
          month: 'short',
          day: '2-digit',
          year: 'numeric',
        })
      } catch (e) {
        publishedAtEl.innerHTML = publishedAt
      }
    }
  }

  const coverImgEl = document.querySelector('[data-element="coverImage"]')
  const coverUrl = getCoverUrl(cover)
  if (coverImgEl) {
    if (coverUrl) {
      coverImgEl.src = coverUrl
      coverImgEl.style.display = 'block'
    } else {
      coverImgEl.style.display = 'none'
    }
  }

  const sepEl = document.querySelector('[data-element="time-separator"]')
  if (sepEl && publishedAt) {
    sepEl.style.display = 'inline'
  }

  const contentBlogEl = document.querySelector('[data-element="contentBlog"]')
  if (contentBlogEl && contents) {
    contentBlogEl.innerHTML = resolveRichText(contents)
  }

  if (activeSlug) {
    const expectedPath = `${BASE_URL}/blog-detail/${activeSlug}`
    if (
      window.location.pathname !== expectedPath ||
      window.location.search ||
      window.location.pathname.includes('.html')
    ) {
      window.history.replaceState(null, '', expectedPath)
    }
  }

  const innerEl = document.querySelector('.contents__blogDetail--inner')
  if (innerEl) innerEl.style.display = 'flex'
}

async function loadBlog(identifier) {
  try {
    // 1. Try direct fetch by identifier (slug or id)
    const directRes = await fetch(
      `${STRAPI_URL}/api/blogs/${encodeURIComponent(identifier)}`,
      requestOptions,
    )
    if (directRes.ok) {
      const result = await directRes.json()
      const dataObj = result?.data?.attributes || result?.data
      if (dataObj) {
        renderBlogDetail(dataObj, result.data?.id || identifier)
        return
      }
    }

    // 2. Fallback: Search all blogs by matching slug / title slug / prefix
    const listRes = await fetch(
      `${STRAPI_URL}/api/blogs?page=1&pageSize=100`,
      requestOptions,
    )
    if (listRes.ok) {
      const listResult = await listRes.json()
      const blogs = listResult?.data || []
      const normIdentifier = slugify(identifier)
      const matched = blogs.find((b) => {
        const data = b?.attributes || b
        const bSlug = slugify(data.slug)
        const bTitleSlug = slugify(data.Title || data.title)
        return (
          b.id === identifier ||
          (bSlug && bSlug === normIdentifier) ||
          (bTitleSlug && bTitleSlug === normIdentifier) ||
          (bSlug && normIdentifier.startsWith(bSlug)) ||
          (bSlug && bSlug.startsWith(normIdentifier)) ||
          (bTitleSlug && normIdentifier.startsWith(bTitleSlug)) ||
          (bTitleSlug && bTitleSlug.startsWith(normIdentifier))
        )
      })

      if (matched) {
        const detailRes = await fetch(
          `${STRAPI_URL}/api/blogs/${encodeURIComponent(matched.id)}`,
          requestOptions,
        )
        if (detailRes.ok) {
          const detailResult = await detailRes.json()
          const dataObj = detailResult?.data?.attributes || detailResult?.data
          if (dataObj) {
            renderBlogDetail(dataObj, detailResult.data?.id || matched.id)
            return
          }
        }
      }
    }

    // 3. If not found at all, show friendly not found message
    const titleEl = document.querySelector('[data-element="title-blog"]')
    if (titleEl) titleEl.innerHTML = 'Blog Post Not Found'
    const contentBlogEl = document.querySelector('[data-element="contentBlog"]')
    if (contentBlogEl) {
      contentBlogEl.innerHTML =
        '<p>The requested blog post could not be found. Please check our <a href="/blog">Blog page</a> for the latest articles.</p>'
    }
    document.title = 'Blog Post Not Found | Wenodo'
    const innerEl = document.querySelector('.contents__blogDetail--inner')
    if (innerEl) innerEl.style.display = 'flex'
  } catch (error) {
    console.error('Error loading blog detail:', error)
  }
}

const identifier = getBlogIdentifier()

if (identifier) {
  loadBlog(identifier)
}

const gridListBlogs = (datas) => {
  if (!Array.isArray(datas)) return
  const gridBlogs = document.querySelector('.otherPost__blogDetail--cards')
  if (!gridBlogs) return

  const _datas = datas.slice(1, 4)
  _datas.forEach((_data) => {
    const data = _data?.attributes || _data
    if (!data) return
    const templateCard = gridBlogs.querySelector('[data-element="blog-card"]')
    if (!templateCard) return
    const cardElement = templateCard.cloneNode(true)
    cardElement.style.display = 'flex'

    const slug = getBlogSlug(data, _data.id)
    const detailUrl = `${BASE_URL}/blog-detail/${slug}`

    const urlLinkImg = cardElement.querySelector(
      '[data-element="url-link-image"]',
    )
    if (urlLinkImg) {
      urlLinkImg.setAttribute('href', detailUrl)
      const img = urlLinkImg.querySelector('img')
      if (img)
        img.src = getCoverUrl(data.cover || data.coverImage || data.ogImage)
    }

    const createdDate = cardElement.querySelector(
      '[data-element="created-date"]',
    )
    const pubDate = data.publishedAt || data.createdAt
    if (createdDate && pubDate) {
      if (typeof moment !== 'undefined') {
        createdDate.innerHTML = moment(pubDate).format('MMM. DD, Y')
      } else {
        try {
          createdDate.innerHTML = new Date(pubDate).toLocaleDateString('en-US', {
            month: 'short',
            day: '2-digit',
            year: 'numeric',
          })
        } catch (e) {
          createdDate.innerHTML = pubDate
        }
      }
    }

    const readingTimeEl = cardElement.querySelector(
      '[data-element="reading-time"]',
    )
    const contents =
      data.contents || data.content || data.Detail || data.summary
    if (readingTimeEl && contents) {
      const textContent =
        typeof contents === 'string' ? contents : resolveRichText(contents)
      readingTimeEl.innerHTML = readingTime(textContent, 300).text
    }

    const titleEl = cardElement.querySelector('[data-element="title"]')
    if (titleEl) titleEl.innerHTML = data.Title || data.title || ''

    const descEl = cardElement.querySelector('[data-element="description"]')
    if (descEl) descEl.innerHTML = data.Detail || data.summary || ''

    const readMoreLink = cardElement.querySelector(
      '[data-element="readMore-link"]',
    )
    if (readMoreLink) {
      readMoreLink.setAttribute('href', detailUrl)
    }

    gridBlogs.appendChild(cardElement)
  })

  const cards = gridBlogs.querySelectorAll('[data-element="blog-card"]')
  if (cards.length > 0) cards[0].remove()
}

fetch(`${STRAPI_URL}/api/blogs?page=1&pageSize=4`, requestOptions)
  .then((response) => {
    if (!response.ok) return null
    return response.json()
  })
  .then((result) => {
    if (result?.data) {
      gridListBlogs(result.data)
    }
    const otherInnerEl = document.querySelector('.otherPost__blogDetail--inner')
    if (otherInnerEl) otherInnerEl.style.display = 'flex'
  })
  .catch((error) => console.error(error))
